
import React from "react";
import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Icons } from "@/components/icons";

interface ProfileLinkProps {
  className?: string;
  onClick?: () => void;
}

const ProfileLink = ({ className = "", onClick }: ProfileLinkProps) => {
  return (
    <Link
      to="/profile"
      className={`${buttonVariants({ variant: "ghost", size: "icon" })} ${className}`}
      onClick={onClick}
    >
      <Avatar className="h-8 w-8">
        <AvatarImage src="" alt="Profile" />
        <AvatarFallback>
          <Icons.user className="h-4 w-4" />
        </AvatarFallback>
      </Avatar>
    </Link>
  );
};

export default ProfileLink;
